import * as DataV2 from './archibus-v2/DataApi'

export const fetchKioskEquipment = () => {
  return DataV2.getDataFromDataSource(
    'ab-self-service.axvw',
    'registerKiosk',
    null
  ).then(result => {
    const {data} = result
    return Promise.resolve(data)
  })
}
